export const topics = [
  {
    slug: "yule",
    name: "娱乐圈",
    en: "Showbiz",
    desc: "顶流动态、剧组路透、合约与商务变动，娱乐圈的风声草动都在这里汇总。",
    count: 486,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20red%20carpet%20walkway%20with%20warm%20gold%20spotlights%20and%20bokeh%20flash%20lights%2C%20deep%20vermillion%20tones%2C%20no%20people%2C%20cinematic%20editorial%20photography&width=700&height=700&seq=dujia-topic-yule&orientation=squarish",
  },
  {
    slug: "wanghong",
    name: "网红圈",
    en: "Creators",
    desc: "直播间翻车、联名撤档、数据争议，短视频与直播生态里最真实的一面。",
    count: 342,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20ring%20light%20and%20smartphone%20rig%20in%20dark%20studio%20with%20warm%20amber%20glow%2C%20modern%20creator%20workspace%20mood%2C%20no%20people%2C%20cinematic%20photography&width=700&height=700&seq=dujia-topic-wanghong&orientation=squarish",
  },
  {
    slug: "yingshi",
    name: "影视瓜",
    en: "Screens",
    desc: "热播剧选角、未播片段、剧宣走向，从片场到播出平台的全程追踪。",
    count: 271,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20vintage%20film%20reel%20and%20clapperboard%20on%20warm%20wooden%20surface%2C%20soft%20amber%20light%2C%20minimal%20cinema%20props%2C%20no%20people%2C%20editorial%20still%20life&width=700&height=700&seq=dujia-topic-yingshi&orientation=squarish",
  },
  {
    slug: "qinggan",
    name: "情感瓜",
    en: "Relationships",
    desc: "恋综动向、同框偶遇、关系变化的时间线整理，只摆事实不替人下结论。",
    count: 198,
    cover:
      "https://readdy.ai/api/search-image?query=two%20warm%20coffee%20cups%20on%20a%20wooden%20table%20with%20soft%20window%20light%2C%20cozy%20minimal%20still%20life%2C%20warm%20neutral%20tones%2C%20no%20people&width=700&height=700&seq=dujia-topic-qinggan&orientation=squarish",
  },
  {
    slug: "shoufa",
    name: "首发追踪",
    en: "First Scoop",
    desc: "站内独家的首发线索与关键转折节点，更新最快的一档栏目。",
    count: 156,
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20glowing%20breaking%20news%20alert%20light%20on%20dark%20backdrop%20with%20warm%20red%20and%20gold%20streaks%2C%20minimal%20high%20contrast%20graphic%20mood%2C%20no%20text&width=700&height=700&seq=dujia-topic-shoufa&orientation=squarish",
  },
];